import { Container, Stack } from "@mui/material";
import Translate from "../../utils/Translate";

export const CompanyNotFound = () => (
  <Container
    sx={{
      //border:"1px solid blue",
      with: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Stack>
      <img src="/static/no-data-empty-box.svg" sx={{ width: 112, height: 112 }} />
      <div>{Translate.get("CompanyNotFound")}</div>
    </Stack>
  </Container>
);
